module.exports = __webpack_public_path__ + "static/logo-eceo-a4343cbb4afbb4af00366cd3b382e9b8.png";